export enum DocumentTypes {
  DLFRONT = 'DL_FRONT',
  Passport = 'PASSPORT',
  Selfie = 'SELFIE',
  QR_BARCODE = 'QR_BARCODE'
}

export enum PassportSide {
  FRONT = 'F',
  BACK = 'B',
}

export enum IdType {
  FRONT = 'IF',
  BACK = 'IB',
}

export enum DocumentTypesShortcat {
  Passport = 'P',
  ID = 'I'
}

export enum ImageTypes {
  Selfie = 'SF',
  Passport = 'PF',
  IdFront = 'IF',
  IdBack = 'IB',
  PassportBack = 'PB'
}
